import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IDualPaymentsCompany,
  IDualPaymentsCompanyDetail,
  IDualPaymentsCompanyUser,
} from "src/models/Maintenance/DualPaymentsCompany.models";

interface DualPaymentsCompanyState {
  companies: IDualPaymentsCompany[];
  companyDetail: IDualPaymentsCompanyDetail | null;
}

const initialState: DualPaymentsCompanyState = {
  companies: [],
  companyDetail: null,
};

const dualPaymentsCompanySlice = createSlice({
  name: "DualPaymentsCompany",
  initialState,
  reducers: {
    setDualPaymentsCompanyList: (
      state,
      action: PayloadAction<IDualPaymentsCompany[]>
    ) => {
      state.companies = action.payload;
    },
    addDualPaymentsCompany: (state, action: PayloadAction<IDualPaymentsCompany>) => {
      state.companies.push(action.payload);
    },
    setDualPaymentsCompanyDetail: (
      state,
      action: PayloadAction<IDualPaymentsCompanyDetail | null>
    ) => {
      state.companyDetail = action.payload;
    },
    updateDualPaymentsCompanyAccessOnDetail: (
      state,
      action: PayloadAction<{
        isDualPaymentsIntegration: boolean | null;
        dualPaymentsBusinessId: string | null;
        canAccessSystem: boolean | null;
      }>
    ) => {
      if (state.companyDetail) {
        state.companyDetail.isDualPaymentsIntegration = action.payload.isDualPaymentsIntegration;
        state.companyDetail.dualPaymentsBusinessId = action.payload.dualPaymentsBusinessId;
        state.companyDetail.canAccessSystem = action.payload.canAccessSystem;
      }
    },
    addDualPaymentsCompanyUserOnDetail: (
      state,
      action: PayloadAction<IDualPaymentsCompanyUser>
    ) => {
      if (state.companyDetail) {
        state.companyDetail.users.push(action.payload);
        state.companyDetail.totalUsers += 1;
        state.companyDetail.activeUsers += action.payload.status ? 1 : 0;
      }
    },
    updateDualPaymentsCompanyUserOnDetail: (
      state,
      action: PayloadAction<IDualPaymentsCompanyUser>
    ) => {
      if (state.companyDetail) {
        const index = state.companyDetail.users.findIndex(
          u => u.userId === action.payload.userId
        );
        if (index !== -1) {
          state.companyDetail.users[index] = action.payload;
          state.companyDetail.activeUsers = state.companyDetail.users.filter(
            u => u.status
          ).length;
        }
      }
    },
    clearDualPaymentsCompanyDetail: state => {
      state.companyDetail = null;
    },
  },
});

export const {
  setDualPaymentsCompanyList,
  addDualPaymentsCompany,
  setDualPaymentsCompanyDetail,
  updateDualPaymentsCompanyAccessOnDetail,
  addDualPaymentsCompanyUserOnDetail,
  updateDualPaymentsCompanyUserOnDetail,
  clearDualPaymentsCompanyDetail,
} = dualPaymentsCompanySlice.actions;

export default dualPaymentsCompanySlice.reducer;
